'use client';

import { useEffect, useState } from 'react';

import { useRouter } from 'next/navigation';

import { Button } from '@/components/ui';
import { motion } from '@/libs';
import { ROUTES } from '@/types/enums';

type PrizeActionsProps = {
  onClose: () => void;
  capitalizer?: string | null;
  canRedraw?: boolean;
  isLastPrize?: boolean;
};

export const PrizeActions = ({
  onClose,
  canRedraw = true,
  isLastPrize = true,
}: PrizeActionsProps) => {
  const { push } = useRouter();
  const [isArmed, setIsArmed] = useState(false);

  useEffect(() => {
    const timeoutId = setTimeout(() => setIsArmed(true), 1000);
    return () => clearTimeout(timeoutId);
  }, []);

  const handleWithdraw = () => {
    onClose();
    if (typeof window !== 'undefined') {
      sessionStorage.setItem('internal-navigation-carteira', 'true');
    }
    push(ROUTES.Enum['/carteira/saque']);
  };

  return (
    <motion.div
      className="flex flex-col items-center gap-2 w-full relative z-20 mb-4"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.7 }}
    >
      {canRedraw && isLastPrize && (
        <motion.div
          className="w-full"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.4, delay: 0.8 }}
        >
          <Button
            variant="primary"
            disabled={!isArmed}
            onClick={handleWithdraw}
            className="w-full rounded-lg bg-white text-primary-600 sm:hover:text-primary-foreground font-semibold h-10 text-sm"
          >
            Resgatar agora
          </Button>
        </motion.div>
      )}
      <motion.div
        className="w-full"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.4, delay: 0.9 }}
      >
        <Button
          variant="secondary"
          disabled={!isArmed}
          onClick={onClose}
          className="w-full rounded-lg border border-white/20 text-white/95 sm:hover:text-secondary-foreground bg-white/5 h-10 text-sm"
        >
          {isLastPrize ? 'Tente novamente' : 'Próximo prêmio'}
        </Button>
      </motion.div>
    </motion.div>
  );
};
